// extracted by mini-css-extract-plugin
export default {"write":"InquiryWrite2_write__n2Itv","selectStarRegist":"InquiryWrite2_selectStarRegist__GBSqp"};